import * as ActionTypes from '../constants/action_types'
import { CALL_API } from '../middleware/api'
import * as utils from './utils'
import Config from '../classes/Config'
import { PlanFilters } from '../classes/FilterHelpers'
import * as f from '../classes/Filters'
import { FILTER_MODE_APPLY, FILTER_MODE_MENU, FILTER_MODE_RESET, RECOMMENDATION_LIMIT } from '../constants/commons'

function fetchFilters () {
  return utils.makeApiCall({
    url: '/api/library/filter',
    actionRequest: ActionTypes.REQUEST_FILTER,
    actionReceive: ActionTypes.SUCCESS_FILTER,
    actionFailure: ActionTypes.REQUEST_FILTER_FAILURE
  })
}

function fetchTopicsWithSize (pageNo, size, typeSearch, nwSearch, cgSearch, nameSearch, order) {
  const body = {}
  if (typeSearch || nwSearch || cgSearch || nameSearch) {
    body.entity_type = (typeSearch && typeSearch!='TYPE' && typeSearch.length != 0)?typeSearch:null
    body.network_label = (nwSearch && nwSearch!='NETWORK' && nwSearch.length != 0)?nwSearch:null
    body.category = (cgSearch && cgSearch!= 'CATEGORY' && cgSearch.length != 0)?cgSearch:null
    body.keyword = nameSearch
    body.order = order
  }
  body.page = pageNo
  body.size = size
  return utils.makeApiCall({
    url: '/api/topics/page/limit',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TOPICS,
    actionReceive: ActionTypes.RECEIVE_TOPICS,
    actionFailure: ActionTypes.REQUEST_TOPICS_FAILURE,
    actionProps: {
      size: size,
      pageNo: pageNo,
      entity_type: typeSearch,
      network_label: nwSearch,
      category: cgSearch,
      order: order
    }
  })
}

function fetchTopicsCount (pageNo, size, typeSearch, nwSearch, cgSearch, nameSearch, order) {
  const body = {}
  if (typeSearch || nwSearch || cgSearch || nameSearch) {
    body.entity_type = (typeSearch && typeSearch!='TYPE' && typeSearch.length != 0)?typeSearch:null
    body.network_label = (nwSearch && nwSearch!='NETWORK' && nwSearch.length != 0)?nwSearch:null
    body.category = (cgSearch && cgSearch!= 'CATEGORY' && cgSearch.length != 0)?cgSearch:null
    body.keyword = nameSearch
    body.order = order
  }
  body.page = pageNo
  body.size = size
  return utils.makeApiCall({
    url: '/api/topics/page/count',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TOPICS_COUNT,
    actionReceive: ActionTypes.RECEIVE_TOPICS_COUNT,
    actionFailure: ActionTypes.REQUEST_TOPICS_COUNT_FAILURE,
    actionProps: {
      size: size,
      pageNo: pageNo,
      entity_type: typeSearch,
      network_label: nwSearch,
      category: cgSearch,
      order: order
    }
  })
}

function fetchTopicDetails (topicId) {
  return utils.makeApiCall({
    url: `/api/topics/${topicId}/details`,
    actionRequest: ActionTypes.REQUEST_TOPIC_DETAILS,
    actionReceive: ActionTypes.RECEIVE_TOPIC_DETAILS,
    actionFailure: ActionTypes.REQUEST_TOPIC_DETAILS_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId
    }
  })
}

function fetchTopicPlan (topicId, opts, module) {
  const url = `/api/topics/v2/${topicId}/plan`
  const body = { ...opts }
  // Convert filters from object to array
  if (body.filters) {
    body.filters = body.filters.filters
    body.num_recommendations = RECOMMENDATION_LIMIT
  }

  return utils.makeApiCall({
    url: url,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TOPIC_PLAN,
    actionReceive: ActionTypes.RECEIVE_TOPIC_PLAN,
    actionFailure: ActionTypes.REQUEST_TOPIC_PLAN_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId,
      page: opts.page,
      filters: opts.filters, // Use the Filters class object
      search: opts.search,
      module: module
    }
  })
}

function fetchTopicPlanAnticipation (topicId) {
  const body = {
    page: 1,
    filters: PlanFilters.Anticipation
    //homepage: true
  }
  return utils.makeApiCall({
    url: `/api/topics/${topicId}/plan`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TOPIC_PLAN_ANTICIPATION,
    actionReceive: ActionTypes.RECEIVE_TOPIC_PLAN_ANTICIPATION,
    actionFailure: ActionTypes.REQUEST_TOPIC_PLAN_ANTICIPATION_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId,
      page: body.page,
      filters: body.filters // Use the Filters class object
    }
  })
}

function fetchTopicPlanMediaPlan (topicId) {
  const body = {
    page: 1,
    filters: f.Filters.Common.AnticipationShowMovie._filters,
    num_recommendations: 100000
  }
  return utils.makeApiCall({
    url: `/api/topics/v2/${topicId}/plan/media`,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TOPIC_MEDIA_PLAN,
    actionReceive: ActionTypes.RECEIVE_TOPIC_MEDIA_PLAN,
    actionFailure: ActionTypes.REQUEST_TOPIC_MEDIA_PLAN_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId,
      page: body.page,
      filters: body.filters
    }
  })
}

function fetchTopicPlanMetrics (topicId) {
  return dispatch => {
    dispatch({
      type: ActionTypes.REQUEST_TOPIC_PLAN_METRICS,
      topicId
    })
    return dispatch({
      [CALL_API]: {
        endpoint: `/api/topics/${topicId}/plan/metrics`,
        authenticated: true,
        types: [ActionTypes.RECEIVE_TOPIC_PLAN_METRICS, ActionTypes.REQUEST_TOPIC_PLAN_METRICS_FAILURE],
        actionAttrs: {
          topicId
        }
      }
    })
  }
}

function fetchTopicPlanSegments (topicId) {
  return dispatch => {
    dispatch({
      type: ActionTypes.REQUEST_TOPIC_PLAN_SEGMENTS,
      topicId
    })
    return dispatch({
      [CALL_API]: {
        endpoint: `/api/topics/${topicId}/plan/segments`,
        authenticated: true,
        types: [ActionTypes.RECEIVE_TOPIC_PLAN_SEGMENTS, ActionTypes.REQUEST_TOPIC_PLAN_SEGMENTS_FAILURE],
        actionAttrs: {
          topicId
        }
      }
    })
  }
}

function fetchTopicPlanDemo (topicId) {
  return dispatch => {
    dispatch({
      type: ActionTypes.REQUEST_TOPIC_PLAN_DEMOGRAPHICS,
      topicId
    })
    return dispatch({
      [CALL_API]: {
        endpoint: `/api/topics/${topicId}/plan/demographics`,
        authenticated: true,
        types: [ActionTypes.RECEIVE_TOPIC_PLAN_DEMOGRAPHICS, ActionTypes.REQUEST_TOPIC_PLAN_DEMOGRAPHICS_FAILURE],
        actionAttrs: {
          topicId
        }
      }
    })
  }
}

function fetchTopicPlanExport (topicId, filename, filters, exportFilters) {
  const t = Config.PlanExportThumbnails
  const n = Config.PlanExportNumRecos
  const url = `/api/topics/${topicId}/plan/export?thumbnails=${t}&num_recommendations=${n}&export_filters=${exportFilters}`
  const body = { }
  body.filters = filters.filters

  return utils.makeApiCall({
    url: url,
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_TOPIC_PLAN_EXPORT,
    actionReceive: ActionTypes.RECEIVE_TOPIC_PLAN_EXPORT,
    actionFailure: ActionTypes.REQUEST_TOPIC_PLAN_EXPORT_FAILURE,
    authenticated: true,
    actionProps: {
      topicId: topicId,
      filename,
      filters,
      exportFilters
    }
  })
}

// -----------------------------------------------------------------------------
// Support functions

function shouldFetchTopicPlanMetrics (topicId, state) {
  const metricState = (state.topics.byId[topicId] || {}).metrics
  return utils.shouldFetch(metricState)
}

function shouldFetchTopicPlanSegments (topicId, state) {
  const segmentState = (state.topics.byId[topicId] || {}).segments
  return utils.shouldFetch(segmentState)
}

function shouldFetchTopicPlanDemo (topicId, state) {
  const demoState = (state.topics.byId[topicId] || {}).demographics
  return utils.shouldFetch(demoState)
}

function shouldFetchMediaPlan (topicId, state) {
  const mediaPlanState = (state.topics.byId[topicId] || {}).mediaPlan
  return utils.shouldFetch(mediaPlanState)
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchTopicsIfNeeded (page, size, typeSearch, nwSearch, cgSearch, nameSearch, order) {
  return (dispatch) => {
      return dispatch(fetchTopicsWithSize(page, size, typeSearch, nwSearch, cgSearch, nameSearch, order))
  }
}

export function fetchTopicsCountIfNeeded (page, size, typeSearch, nwSearch, cgSearch, nameSearch, order) {
  return (dispatch) => {
      return dispatch(fetchTopicsCount(page, size, typeSearch, nwSearch, cgSearch, nameSearch, order))
  }
}

export function setTopicPlanFilters (topicId, filters, filterType, module, mode) {
  return {
    type: ActionTypes.SET_TOPIC_PLAN_FILTERS,
    topicId,
    filterType,
    filters,
    module,
    mode
  }
}

export function resetTopicPlanFilters (topicId) {
  return {
    type: ActionTypes.SET_TOPIC_PLAN_RESET_FILTERS,
    topicId
  }
}

export function fetchTopicDetailsIfNeeded (topicId) {
  return (dispatch, getState) => {
    const state = (getState().topics.byId[topicId] || {}).details
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTopicDetails(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchTopicPlanIfNeeded (topicId, opts, module, mode, isSearch) {
  return (dispatch, getState) => {
    const args = { ...opts }
    args.page = args.page || 1
    const filters = args.filters || null
    const state = (((getState().topics.byId[topicId] || {}).plan || {})[filters] || {})[args.page]
    if (utils.shouldFetch(state) || args.search || isSearch || mode === FILTER_MODE_MENU || mode === FILTER_MODE_RESET || mode === FILTER_MODE_APPLY) {
      return dispatch(fetchTopicPlan(topicId, args, module))
    }
    return Promise.resolve()
  }
}

export function fetchTopicPlanAnticipationIfNeeded (topicId, opts) {
  return (dispatch, getState) => {
    const args = { ...opts }
    args.page = args.page || 1
    const filters = args.filters || null
    const state = (((getState().topics.byId[topicId] || {}).anticipationPlan || {})[filters] || {})[args.page]
    if (utils.shouldFetch(state)) {
      return dispatch(fetchTopicPlanAnticipation(topicId, opts))
    }
    return Promise.resolve()
  }
}

export function fetchTopicPlanTopLevelMetricsIfNeeded (topicId) {
  return (dispatch, getState) => {
    if (shouldFetchTopicPlanMetrics(topicId, getState())) {
      return dispatch(fetchTopicPlanMetrics(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchTopicPlanSegmentsIfNeeded (topicId) {
  return (dispatch, getState) => {
    if (shouldFetchTopicPlanSegments(topicId, getState())) {
      return dispatch(fetchTopicPlanSegments(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchTopicPlanDemoIfNeeded (topicId) {
  return (dispatch, getState) => {
    if (shouldFetchTopicPlanDemo(topicId, getState())) {
      return dispatch(fetchTopicPlanDemo(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchTopicMediaPlanIfNeeded (topicId) {
  return (dispatch, getState) => {
    if (shouldFetchMediaPlan(topicId, getState())) {
      return dispatch(fetchTopicPlanMediaPlan(topicId))
    }
    return Promise.resolve()
  }
}

export function fetchTopicPlanExportIfNeeded (topicId, filename, filters, exportFilters) {
  return dispatch => {
    return dispatch(fetchTopicPlanExport (topicId, filename, filters, exportFilters))
  }
}

export function fetchFiltersIfNeeded () {
  return dispatch => {
    return dispatch(fetchFilters ())
  }
}

function searchResultRequest (val) {
  const body = {}
  body.entity_type = null
  body.network_label = null
  body.category = null
  body.keyword = val
  body.page = 0
  body.size = 30
  return utils.makeApiCall({
     url: '/api/topics/page',
     method: 'POST',
     body: body,
     actionRequest: ActionTypes.SEARCH_RESULT_REQUEST,
     actionReceive: ActionTypes.SEARCH_RESULT_SUCCESS,
     actionFailure: ActionTypes.SEARCH_RESULT_FAILURE,
     actionProps: {
       keyword: val
     }
   })
}

export function getSearchData (val) {
  return (dispatch) => {
    if (val.length != 0) {
      return dispatch(searchResultRequest(val))
    } else {
      return []
    }
  }
}
